'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var reactRouterDom = require('react-router-dom');
var AgentNavigatorProvider = require('../../providers/AgentNavigatorProvider.js');
var ClaimDetailsProvider = require('./ClaimDetailsProvider.js');
var nthHookSettings = require('@narvar/nth-hook-settings');
var useTitanAnalytics = require('../../../../common/providers/titan/useTitanAnalytics.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ClaimDetailsViewRoot = _ref => {
  let {
    children
  } = _ref;
  const titan = useTitanAnalytics["default"]();
  React.useEffect(() => {
    // Note: This effect is only called on first component render
    titan === null || titan === void 0 ? void 0 : titan.page({
      name: 'Claim Details'
    })
    // eslint-disable-next-line no-console
    .catch(e => console.error(e));
  }, [titan]);
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, children);
};
const ClaimDetailsViewRootGuarded = _ref2 => {
  let {
    children
  } = _ref2;
  const params = reactRouterDom.useParams();
  const {
    id
  } = params;
  const {
    navigateToOrderOverview
  } = AgentNavigatorProvider.useAgentNavigator();
  const {
    claimsRecommendationOverturnReasons
  } = nthHookSettings.useSettings();
  if (!id) {
    navigateToOrderOverview();
    return null;
  }
  return /*#__PURE__*/React__default["default"].createElement(ClaimDetailsProvider.ClaimDetailsProvider, {
    value: {
      id,
      claimsRecommendationOverturnReasons
    }
  }, /*#__PURE__*/React__default["default"].createElement(ClaimDetailsViewRoot, null, children));
};
var ClaimDetailsViewRoot$1 = nthHookSettings.withSettingsProvider(ClaimDetailsViewRootGuarded, {
  settingsRequested: `
    claimsRecommendationOverturnReasons {
      Approve {
        label
        value
      }
      Deny {
        label
        value
      }
      Cancel {
        label
        value
      }
    }
  `
});

exports["default"] = ClaimDetailsViewRoot$1;
